export default __webpack_public_path__ + "static/media/hallway-up.b436c02b.mp4";